"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
function swap(arr, from, to) {
    arr.splice(from, 1, arr.splice(to, 1, arr[from])[0]);
}
var ProxyFieldArray = /** @class */ (function () {
    function ProxyFieldArray(observableArray, fieldArraySubFields) {
        var _this = this;
        this.observableArray = observableArray;
        this.fieldArraySubFields = fieldArraySubFields;
        this.insertionCounter = 0;
        Object.setPrototypeOf(this, ProxyFieldArray.prototype);
        this.add = this.add.bind(this);
        this.insert = this.insert.bind(this);
        this.remove = this.remove.bind(this);
        this.forEach = this.observableArray.forEach.bind(this.observableArray);
        this.clear = this.observableArray.clear.bind(this.observableArray);
        mobx_1.reaction(function () { return (_this.fieldArraySubFields.length === 0); }, function (data) {
            // in case fieldArray.subfields became empty (form reset, or all items were removed)
            if (data === true) {
                if (_this.observableArray.length !== 0) { // fieldProxy items exist -> form was resetted, clean up ui
                    _this.observableArray.clear();
                }
            }
        });
    }
    ProxyFieldArray.prototype.add = function () {
        this.observableArray.push(this.insertionCounter.toString());
        this.insertionCounter = this.insertionCounter + 1;
    };
    ProxyFieldArray.prototype.insert = function (index) {
        this.fieldArraySubFields.splice(index, 0, undefined); // prepare a gap for inserting
        this.observableArray.splice(index, 0, this.insertionCounter.toString());
        this.insertionCounter = this.insertionCounter + 1;
    };
    ProxyFieldArray.prototype.remove = function (index) {
        this.observableArray.splice(index, 1);
    };
    ProxyFieldArray.prototype.swap = function (fromIndex, toIndex) {
        // tslint:disable-next-line:max-line-length
        swap(this.fieldArraySubFields, fromIndex, toIndex);
        swap(this.observableArray, fromIndex, toIndex);
    };
    ProxyFieldArray.prototype.map = function (callback) {
        var _this = this;
        return this.observableArray.map(function (item, index) {
            return callback(item, index, _this);
        });
    };
    return ProxyFieldArray;
}());
exports.default = ProxyFieldArray;
//# sourceMappingURL=ProxyFieldArray.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/reactive-mobx-form/lib/ProxyFieldArray.js
// module id = 127
// module chunks = 0